export const GET_ALL_GATE_PASSES_REQUEST = 'GET_ALL_GATE_PASSES_REQUEST';
export const GET_ALL_GATE_PASSES_SUCCESS = 'GET_ALL_GATE_PASSES_SUCCESS';
export const GET_ALL_GATE_PASSES_FAILURE = 'GET_ALL_GATE_PASSES_FAILURE';

export const ADD_GATE_PASS_REQUEST = 'ADD_GATE_PASS_REQUEST';
export const ADD_GATE_PASS_SUCCESS = 'ADD_GATE_PASS_SUCCESS';
export const ADD_GATE_PASS_FAILURE = 'ADD_GATE_PASS_FAILURE';

export const UPDATE_GATE_PASS_REQUEST = 'UPDATE_GATE_PASS_REQUEST';
export const UPDATE_GATE_PASS_SUCCESS = 'UPDATE_GATE_PASS_SUCCESS';
export const UPDATE_GATE_PASS_FAILURE = 'UPDATE_GATE_PASS_FAILURE';

export const GET_GATE_PASS_BY_ID_REQUEST = 'GET_GATE_PASS_BY_ID_REQUEST';
export const GET_GATE_PASS_BY_ID_SUCCESS = 'GET_GATE_PASS_BY_ID_SUCCESS';
export const GET_GATE_PASS_BY_ID_FAILURE = 'GET_GATE_PASS_BY_ID_FAILURE';

export const UPDATE_GP_STATUS_REQUEST = 'UPDATE_GP_STATUS_REQUEST';
export const UPDATE_GP_STATUS_SUCCESS = 'UPDATE_GP_STATUS_SUCCESS';
export const UPDATE_GP_STATUS_FAILURE = 'UPDATE_GP_STATUS_FAILURE';

export const GET_ACTIVE_GATE_PASSES_REQUEST = 'GET_ACTIVE_GATE_PASSES_REQUEST';
export const GET_ACTIVE_GATE_PASSES_SUCCESS = 'GET_ACTIVE_GATE_PASSES_SUCCESS';
export const GET_ACTIVE_GATE_PASSES_FAILURE = 'GET_ACTIVE_GATE_PASSES_FAILURE';
